import { LinkTabProps, Tab } from './types';

export const getVideoMenuTabLinks = ({ recordId }: LinkTabProps): Tab[] => [
  {
    label: 'Info',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/info` : '/dashboard/admin/video-menus/new',
  },
  {
    label: 'Videos',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/videos` : '',
  },
  {
    label: 'Menus',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/menus` : '',
  },
  {
    label: 'Presentation',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/presentation` : '',
  },
  {
    label: 'Options',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/options` : '',
  },
  {
    label: 'Format',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/format` : '',
  },
  {
    label: 'Social Media',
    to: (recordId) ? `/dashboard/admin/video-menus/${recordId}/social-media` : '',
  },
];
